<template>
    <div
        id="lx-online-booking-checkout-review-booking"
        class="lx-online-booking-checkout-review-booking"
    >
        <div class="lx-online-booking-checkout-review-booking__properties__wrapper">
            <div
                class="lx-online-booking-checkout-review-booking__properties__wrapper__property__wrapper"
                v-for="techReservation in reservation.tech_reservations"
                :key="techReservation.tech_reservation.id"
            >
                <online-booking-invoice
                    :techReservation="techReservation"
                />
                <online-booking-checkout-check
                    class="lx-online-booking-checkout-review-booking__properties__wrapper__property__wrapper__check"
                    :tech-reservation="techReservation" 
                    :currency="reservation.currency"
                    :is-editable="reservation.is_editable"
                />
            </div>
        </div>
        <div
            class="lx-online-booking-checkout-review-booking__discount"
            v-if="website.display_coupon_code && reservation.is_editable"
        >
            <form-input
                class="lx-online-booking-checkout-review-booking__discount__input"
                v-model="discountCode"
                floating-label="Discount code"
            />
            <b-button
                class="lx-online-booking-checkout-review-booking__discount__apply"
                :disabled="!discountCode || (discountCode === appliedDiscountCode)"
                @click="applyDiscount"
                variant="primary"
                >Apply</b-button
            >
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import FormInput from '../../../generic/form-input/form-input.vue';
    import OnlineBookingInvoice from '../../common/online-booking-invoice.vue';
    import OnlineBookingCheckoutCheck from '../common/online-booking-checkout-check.vue';

    export default {
        name: 'OnlineBookingCheckoutReviewBooking',
        components: {
            FormInput,
            OnlineBookingInvoice,
            OnlineBookingCheckoutCheck,
        },
        data() {
            return {
                discountCode: null,
                appliedDiscountCode: null,
            };
        },
        computed: {
            ...mapGetters('onlineBooking', ['reservation', 'website']),
        },
        methods: {
            async applyDiscount() {
                try {
                    this.$store.commit('onlineBooking/gotBusy', true);
                    await this.$store.dispatch(
                        'onlineBooking/applyReservationDiscount',
                        {
                            discount_code: this.discountCode,
                        }
                    );
                    this.appliedDiscountCode = this.discountCode;
                    this.successToast({
                        text: 'Discount has been applied.',
                    });
                } catch {
                    this.errorToast({
                        text: 'Invalid discount code.',
                    });
                } finally {
                    this.$store.commit('onlineBooking/gotBusy', false);
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    #lx-online-booking-checkout-review-booking
        .lx-online-booking-checkout-review-booking {
        &__properties__wrapper {
            margin-bottom: 2rem;
            &__property__wrapper {
                margin-bottom: 4rem;
                &:last-child {
                    margin-bottom: 0;
                }
                &__check {
                    margin-top: 3rem;
                }
            }
        }

        &__discount {
            display: flex;

            &__input {
                padding: 0 0.5rem 0 0;
                margin: 0;
                width: 100%;
            }

            &__apply {
                width: 40%;
            }
        }
    }
</style>
